<script>
/* global axios */
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default{
    props: {
        isEdit: { type: Boolean, default: false },
        editObj: { type: Object }
    },
    data(){
        return{
            isLoading: false,
            inboxId: 0,
            conversationId: 0,
            improvement: '',
            action: '',
            id: '',
        }
    },
    computed: {
        ...mapGetters({ currentAccountId: 'getCurrentAccountId' }),
        proxyBase() { return `/api/v1/accounts/${this.currentAccountId}/proxy/knowledge`; },
    },
    emits: ['close', 'refreshList'],
    methods: {
        async createImprovement(){
            const payload = {
                "inbox_id": this.inboxId,
                "conversation_id": this.conversationId,
                "improvement": this.improvement,
                "action": this.action,
            };
            try{
                await axios({
                  method: this.isEdit ? 'put' : 'post',
                  url: `${this.proxyBase}/accounts/${this.currentAccountId}/knowledge_improvement${this.isEdit ? `/${this.id}` : ''}`,
                  data: payload,
                });
                this.$emit('refreshList');
                this.$emit('close');
                useAlert(`Improvement ${this.isEdit ? 'updated' : 'created'}`);
            }catch(err){
                console.error(`Error ${this.isEdit ? 'editing' : 'creating'}` + err);
                useAlert(err.message || `Failed to ${this.isEdit ? 'edit' : 'create'} improvement.`);
            }
        },
    },
    mounted(){
        if(this.isEdit && this.editObj){
            this.inboxId = this.editObj.inbox_id;
            this.conversationId = this.editObj.conversation_id;
            this.improvement = this.editObj.improvement;
            this.action = this.editObj.action;
            this.id = this.editObj.id;
        }
    }
}
</script>

<template>
    <div class="fixed inset-0 flex items-center justify-center bg-slate-900/50 dark:bg-slate-800/50 z-50">
        <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
            <label class="block" v-if="!isEdit">
                <span>Inbox Id</span>
                <input type="number" v-model="inboxId" />
            </label>

            <label class="block" v-if="!isEdit">
                <span>Conversation Id</span>
                <input type="number" v-model="conversationId" />
            </label>

            <label class="block">
                <span>Improvement</span>
                <input type="text" v-model="improvement" />
            </label>

            <label class="block">
                <span>Action</span>
                <input type="text" v-model="action" />
            </label>

            <!-- Action Buttons -->
            <div class="flex justify-between gap-4 w-full">
                <woot-button variant="smooth" color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
                <woot-button variant="smooth" @click="createImprovement">{{ isEdit ? 'Edit' : 'Create' }}</woot-button>
            </div>
        </div>
    </div>
</template>